export enum NavMenuMode {
    HIDDEN,
    NORMAL,
    EBAY,
    VERTICAL
}
